import {useEffect, useState} from "react";
import {findThematicFiguresWithPagination} from "../api/thematicApiClient";

export const useThematicFigures = (thematicId, page, pageSize, reloadTrigger) => {
    const [thematicFigures, setThematicFigures] = useState([]);
    const [pagination, setPagination] = useState(null);

    useEffect(() => {
        const abortController = new AbortController();
        const thematicFiguresWithPagination = findThematicFiguresWithPagination(thematicId, page, pageSize, abortController.signal);

        thematicFiguresWithPagination
            .then(
                (data) => {
                    const thematicFigures = data.thematicFigures;
                    const pagination = data.pagination;

                    setThematicFigures(thematicFigures)
                    setPagination(pagination)
                }
            )
            .catch(
                (error) => console.log(error)
            );

        return () => {
            abortController.abort();
        };
    }, [thematicId, page, pageSize, reloadTrigger]);

    return {thematicFigures, pagination};
};